import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Slide } from '@material-ui/core'

export const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
))

export const useStyles = makeStyles(() => ({
  titlesContainer: {
    width: '500px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '10px',
    border: '1px solid #ff9800',
    borderRadius: '20px',
    textAlign: 'start',
    flexWrap: 'wrap',
    padding: '10px',
  },
  contentRowLead: {
    float: 'left',
    width: '50%',
  },
  contentPropertie: {
    margin: '5px 0',
  },
  contentPropertieLabel: {
    float: 'left',
    width: '100%',
    fontWeight: 'bold',
  },
  titles: {
    float: 'float',
    width: '100%',
    fontSize: '1rem',
    fontWeight: 'bold',
    margin: '0.5rem',
  },
  subTitles: {
    fontSize: '0.8rem',
    fontWeight: '100',
    margin: '0.5rem',
    display: 'contents',
    cursor: 'pointer',
  },
  itemList: {
    textDecoration: 'underline',
    fontWeight: 'bold',
    margin: '5px',
  },
}))
